export default (amount: number) => {
    const decimalValue = amount/100;
    const currency = decimalValue.toLocaleString("en-GB", {style:"currency", currency:"GBP"});
    return currency.split(".")[0]; 
    //return `£${amount/100}`;
}